<template>
    <div>
        <Loading v-if="loading" type="line" :center="false" />
        <table class="table table-responsive-xs">
            <thead>
                <tr>
                    <th>
                        <span class="title-header">Produto</span>
                    </th>
                    <th>
                        <span class="title-header">Descrição</span>
                    </th>
                    <th class="text-center">
                        <span class="title-header">Código/Patrimônios</span>
                    </th>
                    <th class="text-center">
                        <span class="title-header">Qtd</span>
                    </th>
                    <th class="text-center"></th>
                    <th class="text-center">
                        <span class="title-header">Status</span>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-for="itemMovementBulk in sortedList" :key="itemMovementBulk.id">
                <ItemMovementBulkOutPut v-if="movementBulkType == 1" :itemMovementBulk="itemMovementBulk"
                    :loading="loading" />
            </tbody>
            <tbody v-show="itemsMovementBulk.length == 0">
                <tr>
                    <td colspan="12">
                        <span>Nenhum produto encontrado!</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <Modal title="Patrimônios" :width="800" :height="750" v-if="showModal('patrimonies')">
            <ItemsPatrimony :patrimonies="patrimonies" />
        </Modal>

        <Modal title="Erro(s)" :width="600" :height="750" v-if="showModal('errors')">
            <Errors :errors="errors" />
        </Modal>

        <Modal title="Distribuição" :width="800" :height="750" v-if="showModal('distribution')">
            <RentsDistribution :rentsDistribution="rentsDistribution" :itemMovementBulk="itemMovementBulk" />
        </Modal>


    </div>
</template>

<script>


import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import Errors from './Errors.vue'
import ItemsPatrimony from './ItemsPatrimony.vue';
import RentsDistribution from './RentsDistribution.vue'
import ItemMovementBulkOutPut from './ItemMovementBulkOutPut.vue';

import { mapActions, mapMutations, mapState, mapGetters } from "vuex";

export default {
    name: "ItemsMovementBulk",
    props: ["movementBulkType"],
    components: {
        Modal, Loading, ItemMovementBulkOutPut,
        ItemsPatrimony, Errors, RentsDistribution
    },
    data() {
        return {
            id: this.$route.params.id,
            urlGetAll: "/api/v1/operational/items-movement-bulk/get-all",
            itemsMovementBulk: [],
            itemsMovementBulkFiltered: [],
            itemMovementBulk: {},
            patrimonies: [],
            errors: [],
            rentsDistribution: [],
            loading: true,
        }
    },
    created() {
        this.getAll();
    },
    computed: {
        ...mapState("generic", ["event"]),
        ...mapGetters("generic", ["showModal"]),
        sortedList() {
            return [...this.itemsMovementBulkFiltered].sort((a, b) => {
                if (a.categoryProductName < b.categoryProductName) return -1;
                if (a.categoryProductName > b.categoryProductName) return 1;
                if (a.productName < b.productName) return -1;
                if (a.productName > b.productName) return 1;
                return 0;
            });
        },
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        ...mapMutations("generic", ["openModal", "removeLoading"]),
        async getAll() {
            this.loading = true;
            let params = {
                url: this.urlGetAll,
                obj: { id: this.id },
            };
            const response = await this.getApi(params);
            this.itemsMovementBulk = response.content;
            this.loading = false;
            this.removeLoading(["btnRefresh"]);
        },
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "productCreated" || event.name == "productBulkUpdate" || event.name == "movementBulkUpdated" || event.name == "productBulkRemoved") {
                    this.patrimonies = event.data;
                    this.getAll();
                }

                if (event.name == "openPatrimonies") {
                    this.openModal("patrimonies");
                    this.patrimonies = event.data;
                }

                if (event.name == "openError") {
                    this.openModal("errors");
                    this.errors = event.data;
                }

                if (event.name == "openDistribution") {
                    this.openModal("distribution");
                    this.rentsDistribution = event.data.rentsDistribution;
                    this.itemMovementBulk = event.data;
                }

                if (event.name == "updateStatusItemBulk") {
                    this.itemsMovementBulk.forEach(item => {
                        if (item.id == event.data.itemMovementBulkId) {
                            item.status = event.data.response.status;
                            item.errors = event.data.response.messagesError;
                        }
                    });
                }

            },
            deep: true,
        },
        itemsMovementBulk: {
            handler() {
                this.itemsMovementBulkFiltered = this.itemsMovementBulk;
            },
            deep: true,
        },
    }
}

</script>
<style scoped>
.table th,
.table td {
    height: 10px !important;
    padding-left: 5px !important;
    padding-top: 7px !important;
    padding-bottom: 5px !important;
    padding-right: 5px !important;
    padding-left: 10px !important;
    border-bottom: 0px !important;
}

.title-header {
    font-size: 14px;
    color: #757d8c;
    font-weight: 400;
    text-transform: uppercase;
}

.title-main {
    font-weight: 500;
    margin-right: 3px;
    font-size: 15px;
}
</style>